// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__Ai7Qu","slideUp":"Toast_slideUp__X+LG5"};